/** @format */
/* jshint esversion: 6 */
/* globals moment */

(function () {
    "use strict";

    // Guard: prevents duplicate listener registration if this script is injected twice.
    if (window._eddScriptLoaded) return;
    window._eddScriptLoaded = true;

    const DEBUG = false;

    // Global interval ID — survives script re-injection; any new init clears old ghost timers.
    window.eddTimerIntervalId = window.eddTimerIntervalId || null;

    // Namespaced state — calculated once at init, read by tick().
    window.EDD_State = window.EDD_State || {
        targetMs:    null,
        displayMode: null,
        cutoffLabel: ""
    };

    function pad(n) {
        return String(n).padStart(2, "0");
    }

    /**
     * Uses moment.tz ONCE to find the next dispatch event.
     * Stores the result in window.EDD_State as plain numbers so the interval
     * never needs moment again.
     * Returns true on success, false if moment.tz is not yet available.
     */
    function calculateNextDispatch() {
        if (typeof moment === "undefined" || typeof moment.tz === "undefined") {
            return false;
        }

        const cutoffEl   = document.getElementById("target-cutoffhour");
        const cutoffHour = cutoffEl ? parseInt(cutoffEl.textContent.trim(), 10) || 13 : 13;

        const dt = new Date();
        dt.setHours(cutoffHour, 0, 0, 0);
        window.EDD_State.cutoffLabel = dt
            .toLocaleString("en-US", { hour: "numeric", hour12: true })
            .replace(/\s+/g, "")
            .toLowerCase();

        const now = moment().tz("Australia/Brisbane");
        let daysForward = 0;
        let targetMoment, mode;

        do {
            const dispatch = moment(cutoffHour + ":00:00", "HH:mm:ss")
                .tz("Australia/Brisbane")
                .add(daysForward, "days");
            const endOfDay = moment(cutoffHour + ":00:00", "HH:mm:ss")
                .tz("Australia/Brisbane")
                .add(daysForward, "days")
                .endOf("day");

            if (now.isBefore(dispatch)) {
                targetMoment = dispatch;
                mode = "b4cutoff";
            } else {
                targetMoment = endOfDay;
                mode = "b4endofday";
            }
            daysForward++;
        } while (targetMoment.diff(now, "milliseconds") <= 0);

        const eventDay = targetMoment.isoWeekday();
        if (eventDay > 5 || (eventDay === 5 && mode === "b4endofday")) {
            mode = "nonbusinessday";
        }

        window.EDD_State.targetMs    = targetMoment.valueOf();
        window.EDD_State.displayMode = mode;

        if (DEBUG) console.log("EDD: next dispatch at", new Date(window.EDD_State.targetMs), "mode=", mode);
        return true;
    }

    /**
     * Called every second by setInterval.
     * Uses only Date.now() and plain arithmetic — no moment dependency.
     * Only updates the countdown timer text; static strings are set once in initEddCountdown().
     */
    function tick() {
        const now = Date.now();

        if (!window.EDD_State.targetMs || now >= window.EDD_State.targetMs) {
            clearInterval(window.eddTimerIntervalId);
            window.eddTimerIntervalId = null;
            window.EDD_State.targetMs = null;
            initEddCountdown();
            return;
        }

        let text;
        const mode = window.EDD_State.displayMode;

        if (mode === "nonbusinessday") {
            text = window.EDD_State.cutoffLabel + " Monday";
        } else if (mode === "b4endofday") {
            text = window.EDD_State.cutoffLabel + " Tomorrow";
        } else {
            const remaining = window.EDD_State.targetMs - now;
            const totalSecs = Math.floor(remaining / 1000);
            const h = Math.floor(totalSecs / 3600);
            const m = Math.floor((totalSecs % 3600) / 60);
            const s = totalSecs % 60;
            text = pad(h) + "h " + pad(m) + "m " + pad(s) + "s";
        }

        if (DEBUG) console.log("EDD Ticker: mode=" + mode + ", text=" + text);

        document.querySelectorAll(".edd-cd-time").forEach(function (el) {
            el.textContent = text;
        });
    }

    function initEddCountdown() {
        if (window.eddTimerIntervalId) {
            clearInterval(window.eddTimerIntervalId);
            window.eddTimerIntervalId = null;
            if (DEBUG) console.log("EDD Countdown: Cleared previous instance.");
        }

        if (DEBUG) console.log("EDD Countdown: Initializing...");

        if (!calculateNextDispatch()) {
            setTimeout(initEddCountdown, 400);
            return;
        }

        // Static text set once per init — these strings never change during a session.
        document.querySelectorAll(".edd-db-text1").forEach(function (el) {
            el.textContent = "Next dispatch";
        });
        document.querySelectorAll(".edd-db-text2").forEach(function (el) {
            el.textContent = "Estimate your delivery date here...";
        });

        tick();
        window.eddTimerIntervalId = setInterval(tick, 1000);

        if (DEBUG) console.log("EDD: Timer started, intervalId=", window.eddTimerIntervalId);
    }

    document.addEventListener("DOMContentLoaded",        initEddCountdown);
    document.addEventListener("shopify:section:load",    initEddCountdown);
    document.addEventListener("shopify:section:reorder", initEddCountdown);
    document.addEventListener("shopify:section:select",  initEddCountdown);
    document.addEventListener("page:loaded",             initEddCountdown);
    document.addEventListener("turbo:load",              initEddCountdown);

    window.initEddCountdown = initEddCountdown;
})();
